/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NoticeDto } from '../models/NoticeDto';
import type { PaginatedNoticeListDto } from '../models/PaginatedNoticeListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NoticeService {
  /**
   * 공지사항 가져오기
   * @returns PaginatedNoticeListDto
   * @throws ApiError
   */
  public static noticeControllerGetAllNotices({
    page,
    itemsPerPage,
  }: {
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedNoticeListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/notices',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }

  /**
   * 공지사항 하나 가져오기
   * @returns NoticeDto
   * @throws ApiError
   */
  public static noticeControllerGetNoticeById({
    noticeId,
  }: {
    noticeId: number;
  }): CancelablePromise<NoticeDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/notices/{noticeId}',
      path: {
        noticeId: noticeId,
      },
    });
  }
}
